import styled from 'styled-components';
const DetailTabStyled = styled.div`
  height: 100%;
  .MuiPaper-elevation4 {
    color: #212121;
    background-color: transparent;
    box-shadow: none;
  }
  .MuiTabs-root {
    padding-left: 32px;
    font-size: 16px;
    .MuiButtonBase-root {
      font-size: 16px;
    }
    border-bottom: 1px solid #f5f5f5;
    .MuiTabs-indicator {
      /* display: none; */
    }
    .Mui-selected {
      border-radius: 4px;
      /* background-color: ${(props) => props.theme.palette.text.primary}; */
    }

    .MuiButtonBase-root {
      /* margin-right: 24px; */
      padding: 16px 24px;
      /* height: 48px; */
      width: 180px;
      .MuiTab-wrapper {
        font-size: 16px;
      }
    }
  }
  .second-wrapper {
    display: flex;
    height: 100%;
    padding-top: 8px;
    flex-direction: column;
    background: #fff;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
  .tab-content {
    flex-grow: 2;
  }
  .content-wrapper {
    height: 100%;
    overflow-x: hidden;
  }
  .dvzIvK {
    height: 100%;
  }
  .button-group {
    height: 100px;
    border: 1px solid red;
  }
`;
export default DetailTabStyled;
